import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$7374 } from '/opt/atlassian/pipelines/agent/build/schemes/auth/sso.ts'
import { default as Scheme$69a4 } from '/opt/atlassian/pipelines/agent/build/schemes/auth/oidc.ts'
import { default as Scheme$5225 } from '/opt/atlassian/pipelines/agent/build/schemes/auth/keycloak.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/login",
    "home": "/",
    "callback": "/logged-in"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": false,
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "sso"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // sso
  $auth.registerStrategy('sso', new Scheme$7374($auth, {
  "clientId": "client-id",
  "accessType": "offline",
  "acrValues": "1",
  "endpoints": {
    "configuration": "openid-configuration"
  },
  "name": "sso"
}))

  // oidc
  $auth.registerStrategy('oidc', new Scheme$69a4($auth, {
  "clientId": "kundenportal",
  "accessType": "offline",
  "endpoints": {
    "configuration": "undefined/auth/realms/kundenportal/.well-known/openid-configuration"
  },
  "name": "oidc"
}))

  // local
  $auth.registerStrategy('local', new Scheme$5225($auth, {
  "endpoints": {
    "login": {
      "url": "undefined/auth/realms/kundenportal/protocol/openid-connect/token",
      "method": "post"
    },
    "refresh": {
      "url": "undefined/auth/realms/kundenportal/protocol/openid-connect/token",
      "method": "post"
    },
    "logout": {
      "url": "undefined/auth/realms/kundenportal/account/sessions/",
      "method": "delete"
    },
    "user": false
  },
  "token": {
    "property": "access_token"
  },
  "grantType": "password",
  "clientId": "kundenportal",
  "scope": [
    "profile",
    "email"
  ],
  "user": {
    "autoFetch": false
  },
  "name": "local"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
